export default __webpack_public_path__ + "static/media/fsiRealCase2-mobile.e87003e2.jpg";